import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import lodash from 'lodash-es';
import { useTheme } from 'styled-components';
import Horizontal from './horizontal';
import Vertical from './vertical';
import { Direction } from '../../constants';

// for now we are using same logo for default and outline
const LogoVariations = {
  outline: {
    [Direction.vertical]: Vertical,
    [Direction.horizontal]: Horizontal
  },
  default: {
    [Direction.vertical]: Vertical,
    [Direction.horizontal]: Horizontal
  }
};
const uniqueId = lodash.uniqueId('upgrade-logo-');
const UpgradeLogo = props => {
  const theme = useTheme();
  const {
    title = 'Upgrade Logo',
    outline,
    direction,
    color = theme.palette.actionablePrimary,
    variation = outline ? 'outline' : 'default',
    ...rest
  } = props;
  const Vector = LogoVariations[variation][direction];
  return /*#__PURE__*/React.createElement(Vector, _extends({
    role: "img",
    uniqueId: uniqueId,
    title: title
  }, rest, {
    color
  }));
};
export default UpgradeLogo;
//# sourceMappingURL=index.js.map